import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

// allowed characters based on ScoreboardDateFormat.kt
const allowedCharacters = ['m', 'd', 'y', ' ', '-', '/', ',']
const allowedSeparators = [' ', '-', '/', ',']

/**
 * Validates a user-supplied date format pattern
 */
function dateFormatPatternValidator(val) {
	if (_.isEmpty(val)) {
		return
	}

	let validationMessage = i18n.get('admin.import.transform.dateFormat.invalid')

	val = val.toLowerCase()
	// check minimum length ('m-d-y')
	if (val.length < 5) {
		return validationMessage
	}
	let separators = []
	// make sure it only includes allowed characters
	for (let i = 0; i < val.length; i++) {
		let c = val.charAt(i)
		if (!_.includes(allowedCharacters, c)) {
			return i18n.get('datasets.filters.date.equation.invalid.char')
		}
		// collect separators for later check
		if (_.includes(allowedSeparators, c)) {
			separators.push(c)
		}
	}

	// make sure it contains at least m, d and y
	if (val.indexOf('m') < 0 || val.indexOf('d') < 0 || val.indexOf('y') < 0) {
		return validationMessage
	}

	// we should have at least 2 separators
	if (separators.length < 2) {
		return validationMessage
	}

}

export default dateFormatPatternValidator
dateFormatPatternValidator.__filename__ = 'components/validators/date-format-pattern-validator.js'
